import React, { useState, useEffect } from "react";
import PreLoaderWidget from '../../../components/Loader';
import Receituario from "../../../components/Receituario";
import ModalComponent from "../../../components/Modal";
import CardReceituario from "./components/CardReceituario";

const ContReceituario = ({interacao, receituario, paciente, preloadReceituario, usuario}) => {

    const [ itemReceituario, setItemReceituario ] = useState(null);
    const [ visibleModal, setVisibleModal ] = useState(false);

    const openModal = (item) => {
        setVisibleModal(true);
        setItemReceituario(item);
    }

    useEffect(() => {
        console.log('dados do paciente', paciente);
    },[])

    return(
      <>
        <div className="p-2">
            {preloadReceituario ? (<PreLoaderWidget />) : receituario
                ? receituario.map((item, index) => {

            return (
                <div className="row">
                    <div className="col-sm-12">
                        <CardReceituario
                            interacao={interacao}
                            paciente={paciente}
                            profissional={item.profissional.nome}
                            DataCriacao={item.receituario.DataCriacao}
                            prescricao={item.receituario.prescricao}
                            receituarioId={item.id}
                            OpenModal={() => openModal(item)}
                            Hora={item.receituario.Hora}
                        />
                    </div>
                </div>
            );
            })
            : null}
        </div>
        <ModalComponent
            style={{ zIndex: 9999999999999 }}
            openModal={visibleModal}
            closeModal={() => setVisibleModal(false)}>
            <Receituario
                item={itemReceituario}
                usuario={usuario}
                idPaciente={paciente.id}
                paciente={null}
            />
        </ModalComponent>
    </>)
}

export default ContReceituario;